import { Injectable } from '@angular/core';
import { forkJoin, from, Observable, of } from 'rxjs';
import { exhaustMap } from 'rxjs/operators';
import { MSRemoteLoggerCategory, MSRemoteLoggerSeverity } from 'src/app/adapters/remote-logger/utils/remote-logger.utils';
import { CONSTANTS } from 'src/app/services/config.service';
import { PrefsService } from 'src/app/services/prefs.service';
import { RemoteLoggerUseCase } from '../remote-logger/remote-logger.use-case';
import { UserStorageUseCase } from '../user-storage/user-storage.use-case';

@Injectable({
  providedIn: 'root'
})
export class MigrateServerAddressUseCase {
  constructor(
    private readonly storageUseCase: UserStorageUseCase,
    private readonly remoteLoggerUseCase: RemoteLoggerUseCase,
    private readonly prefsService: PrefsService,
  ) {}

  execute(): Observable<void> {
    const serverAddressObs = this.storageUseCase.getServerAddress();
    const authCodePromise = this.getAuthCode();

    const migrateServerAddressObs = forkJoin([
      serverAddressObs,
      from(authCodePromise),
    ]).pipe(
      exhaustMap(([serverAddress, authCode]) => {
        if (!serverAddress || !serverAddress.includes('/en')) {
          return of<void>(undefined);
        }

        const newAddress = serverAddress.replace('/en', '');
        this.remoteLoggerUseCase.log(`Removing /en from server address for ${authCode}`, MSRemoteLoggerCategory.MIGRATE_SERVER_ADDRESS_USE_CASE, MSRemoteLoggerSeverity.INFO);

        const serverAddressObs = this.storageUseCase.setServerAddress(newAddress);
        return serverAddressObs;
      }),
    )

    return migrateServerAddressObs;
  }

  private async getAuthCode(): Promise<string | undefined> {
    if (CONSTANTS.USE_SERVER_DB) {
      const authParams = await this.prefsService.getAuthParams();
      return authParams?.['household_authcode'];
    }

    const authCode = await this.prefsService.getPromiseOfTypeOrDefault<string>('authCode', undefined);
    return authCode;
  }
}